import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'standing' })
export class StandingPipe implements PipeTransform {

  transform(value?: boolean): string {
    return value ? 'Good' : 'Warning'
  }
}
